import globals from "../partials/global-variables";

const { colors } = globals;

export default {
  container: {
    "&.answer": {
      display: "flex",
      flex: "0 1 auto",
      minWidth: "calc(20% - 15px)",
      flexDirection: "column",
      [`@media (${globals.breakpoints.$mdMax})`]: {
        flex: "0 1 calc(50% - 15px)"
      },
      [`@media (${globals.breakpoints.$sxs})`]: {
        flex: "0 1 calc(100% - 15px)"
      },
      "& .answer-label": {
        background: "transparent",
        flex: "0 0 auto",
        width: "100%",
        border: `1px solid ${colors.black}`,
        cursor: "pointer",
        "& .input-text": {
          color: "#1a1a1a"
        }
      },
      "&.is-disabled": {
        cursor: "not-allowed",
        "& .image-wrapper": {
          opacity: 0.4
        },
        "& .answer-label": {
          pointerEvents: "none",
          borderColor: colors.gray3,
          color: colors.gray3,
          cursor: "not-allowed"
        },
        "& .custom-input:after": {
          opacity: 0.5
        }
      },
      "& .answer-info-text": {
        width: "100%"
      },
      "& .image-wrapper": {
        height: "250px"
      },
      "& .image": {
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        height: "100%",
        width: "100%",
        maxWidth: "100%",
        display: "block"
      },
      "& .input-wrapper": {
        alignItems: "center",
        padding: "15px",
        display: "flex"
      },
      "& input": {
        display: "none",
        "&:checked + .custom-input::after": {
          visibility: "visible"
        }
      },
      "& .custom-input": {
        marginRight: "10px",
        maxWidth: "20px",
        maxHeight: "20px",
        minWidth: "20px",
        minHeight: "20px",
        background: `${colors.gray}`,
        borderRadius: "50px",
        position: "relative",
        "&::after": {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%,-50%)",
          visibility: "hidden",
          borderRadius: "50px",
          content: "''",
          display: "block",
          background: `${colors.blue2}`,
          width: "12px",
          height: "12px"
        }
      }
    },
    "&.answerFullWidth": {
      minWidth: "unset !important",
      [`@media (${globals.breakpoints.$mdMax})`]: {
        flex: "0 1 calc(100% - 15px) !important",
        width: "100%"
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        flex: "0 1 calc(100% - 15px) !important",
        width: "100%"
      }
    }
  }
};
